/**
 * UI actions - Used to store users UI preferences
 */

import {
    PIN_SIDEBAR,
    UNPIN_SIDEBAR,
    OPEN_SIDEBAR,
    CLOSE_SIDEBAR,
    SET_TIMESHEET_GROUP_BY,
    SET_PICK_SCHEDULE_LAYOUT
} from './constants';

import {
    PinSidebarActionCreator,
    UnpinSidebarActionCreator,
    OpenSidebarActionCreator,
    CloseSidebarActionCreator,
    SetTimesheetGroupByActionCreator,
    SetPickScheduleLayoutActionCreator
} from './types';

export const pinSidebar: PinSidebarActionCreator = () => {
    return {
        type: PIN_SIDEBAR
    };
};

export const unpinSidebar: UnpinSidebarActionCreator = () => {
    return {
        type: UNPIN_SIDEBAR
    };
};

export const openSidebar: OpenSidebarActionCreator = () => {
    return {
        type: OPEN_SIDEBAR
    };
};

export const closeSidebar: CloseSidebarActionCreator = () => {
    return {
        type: CLOSE_SIDEBAR
    };
};

export const setTimesheetGroupBy: SetTimesheetGroupByActionCreator = (key) => {
    return {
        type: SET_TIMESHEET_GROUP_BY,
        payload: {
            key
        }
    };
};

export const setPickScheduleLayout: SetPickScheduleLayoutActionCreator = (
    layoutName
) => {
    return {
        type: SET_PICK_SCHEDULE_LAYOUT,
        payload: {
            layoutName
        }
    };
};
